<template>
<div class="form-module">

    <not-allowed v-if="!AllowedDisplay && datas.access!==false" :data="datas"></not-allowed>

        <v-row no-gutters>

            <v-col v-for="item in list" :key="item.id || item.cle || item.value" :data-guide-target="`field:${item.cle || item.value}`" :data-guide-field="item.cle || item.value" :class="['form-module__field', online ? 'col-md-auto col-12' : 'col-12']">
                <rights-indicator :checks="fieldInspectionChecks(item, valFields, typePage !== 'new')" :label="item.name || item.cle" />
                
 <v-icon  x-small v-if="mod && !isRightsPreview" @click="editField(item)">mdi-pencil</v-icon>

 <v-btn v-if="mod && !isRightsPreview && $store.getters.currentUser.type == 3 && item.create && Number.isSafeInteger(Number(item.id)) && Number(item.id) > 0" icon x-small
     title="Voir ce champ dans le pilotage système" aria-label="Voir ce champ dans le dashboard"
     :to="{ name: 'engine-dashboard', query: { tab: 'catalog', metier: $store.getters.currentUser.metier, element_type: 'field', element_id: String(item.id) } }" @click.stop>
     <v-icon size="16">mdi-view-dashboard-outline</v-icon>
 </v-btn>

 <v-icon small v-if="mod && !isRightsPreview && item.create" @click="editDroit(item)">mdi-account-eye-outline</v-icon>


                <component 
                    :is="getFieldComponent(item.format)" 
                    :item="item" 
                    :keyup="onkeyup" 
                    :change="onChange"
                    :modalKey="modalKey"
                    type="form"
                    :page="page"
                    :modal="modal"
                    :hook="hook"
                    :mod="mod && !isRightsPreview"
                    :valField="valFields[item.value]"
                    />            
            </v-col>


        </v-row>

        <v-row v-if="typeSave=='inside'">
            <v-col class="text-center">
                <v-btn :data-guide-target="`module:${idmodule}:submit`" data-guide-manual-only="true" class="primary" @click="validate" :disabled="!valid">{{dependencies.butname}}</v-btn>
            </v-col>
        </v-row>


</div>
</template>



<script>
import { client } from '../mixins'; 
import { openFieldEditor } from '@/components/engine/editField/navigation'
import { openRightsEditor } from '@/components/engine/editDroits/navigation'
    export default {

    mixins : [client],
    name : 'FormModule',
        data: function() {
            
            return {
                valid : true,
                show : false,
                AllowedDisplay : true,
                list : [],
                searchvalues : [],
                params : {},
                datas : [],
                dependencies : [],
                typeSave : '',
                online : false,
                keyForm : '',
                valFields : {},
                url : '',
            }
        },

        computed: {
        reloadForms() {
            return this.$store.getters.getReloadForms(this.modalKey)
        }
        },
        watch: {
            //permet de réattribuer les valeurs des champs apres rafraichissement des valeurs via l'API par un this.initForm
            reloadForms(val) {
                if (val && val.length) {
                    var newValFields = this.$store.getters.listForm(this.modalKey).fields;
                    //let reload = false;
                    Object.keys(newValFields).forEach(key => {
                        this.datas.fields.forEach((f)=> {
                            val.forEach((keyToReload)=> {
                                if(f.value == key && keyToReload==key && newValFields[key]!=this.valFields[key]) {
                                    //console.log('reload pour ',key,' : ',newValFields[key],'-',this.valFields[key]);
                                    this.$set(this.valFields, key, newValFields[key]);
                                    
                                }
                            })

                        })
                    })

                    if(val[0]=='all') {
                        Object.keys(newValFields).forEach(key => {
                            this.datas.fields.forEach((f)=> {
                                    if(f.value == key && newValFields[key]!=this.valFields[key]) {
                                        //console.log('reload pour ',key,' : ',newValFields[key],'-',this.valFields[key]);
                                        this.$set(this.valFields, key, newValFields[key]); 
                                    }
                            })
                        })                    
                    }                
                }

            }
        },

        methods :  {
            guideModuleTargets() {
                return Array.from(this.$el.querySelectorAll('[data-guide-field]')).map(element =>
                    this.guideTarget(`field:${element.getAttribute('data-guide-field')}`, () => element, {}, element.getAttribute('data-guide-field')))
            },

            validate() {
                this.validateForm({form:this.$refs.form,page:this.page,modalKey:this.modalKey,fields:this.valFields,urlSend:this.url,
                        ifNotValid:()=>{
                            this.$store.dispatch('changeParamForm',{page:this.modalKey,type:'validate',value:0})
                        },
                        callback:()=> {                      
                        this.$store.dispatch('removeForm', { uid:this.modalKey })
                     }})

            },

            callAPI : function() {
                this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params}}).then((resp) => {

                  this.manageDatas(resp.data);

                })


            },   

            manageDatas(data) {
                this.datas = data
                this.dependencies = data.dependencies
                if(!data.success) {
                this.AllowedDisplay = false; 
                return false;
                }
                this.typeSave = data.typesave;
                this.list   = this.datas.fields;
                this.keyForm = data.paramsave.key
                this.online = data.online
                // si le form ne teint pas compte du store (indépendante de la page)


                switch(this.typeSave) {
                    case 'vuex' :
                        this.list.forEach((field)=>{                       
                            this.valFields[field.cle] = (this.dependencies.datas && this.dependencies.datas[field.cle]) ? this.dependencies.datas[field.cle] : "";
                            this.$store.dispatch('pushIForm', { value:this.valFields[field.cle], champ:field.cle, key:this.keyForm })
                        })
                        break;
                    case 'localstorage' :
                        this.list.forEach((field)=>{
                            this.valFields[field.cle] = (this.dependencies.datas[field.cle]) ? this.dependencies.datas[field.cle] : "";
                        })
                        localStorage.setItem(this.keyForm, JSON.stringify(this.dependencies.datas));
                        break;
                    case 'inside' :
                        this.valFields = this.dependencies.datas;
                        this.url = this.dependencies.url;
                        break;
                    default :
                    var newValFields = this.$store.getters.listForm(this.modalKey).fields;
                    Object.keys(newValFields).forEach(key => {
                        this.$set(this.valFields, key, newValFields[key]);
                        });
                        break;
                } 

            this.datas.fields.forEach((f)=> {
                if(this.$store.getters.listForm(this.modalKey) && typeof this.$store.getters.listForm(this.modalKey).fields[f.value]=='undefined') {
                    this.$store.dispatch('pushForm', { page:this.modalKey, value:null, champ:f.value })
                }
            })
            

                this.show = true  
            },

             onkeyup : function(item,model) {

                switch(this.typeSave) {
                    case 'vuex' :
                    this.$store.dispatch('pushIForm', { value:model, champ:item.value, key:this.keyForm })
                        break;
                    case 'localstorage' :
                        var vals = JSON.parse(localStorage.getItem(this.keyForm));
                        vals[item.value] = model;
                        localStorage.setItem(this.keyForm, JSON.stringify(vals));
                        break;
                    case 'inside' :
                        break;
                    default :
                        // on met a jour l'array qui permet l'intégration dans l'API
                        this.$store.dispatch('pushForm', { page:this.modalKey, value:model, champ:item.value })

                        break;
                }
                    
                    this.$set(this.valFields, item.value, model);
                    
                
            },

            onChange : function(item,model,selectedKey) {
                var realValue = model;
                
                    if((item.format=='autocomplete' || item.format=='select')) {
                        realValue = [];
                        
                        if(item.defaultprops.multiple) {
                            for(var selected in model) {
                                if(typeof model[selected] == 'object') { realValue.push(model[selected][selectedKey]) } else { realValue.push(model[selected]); }
                            }
                        } else {
  
                        realValue = (typeof model =='object' && model!=null) ? model[selectedKey] : model;  
                          
                        }

                    } 
                
                    switch(this.typeSave) {
                    case 'vuex' :
                    this.$store.dispatch('pushIForm', { value:realValue, champ:item.value, key:this.keyForm })
                        break;
                    case 'localstorage' :

                        break;
                    case 'inside' :
                        break;
                    default :
                    // on met a jour l'array qui permet l'intégration dans l'API
                    this.$store.dispatch('pushForm', { page:this.modalKey, value:realValue, champ:item.value })
                    break;
                    }

                this.$set(this.valFields, item.value, realValue);
            },

            editField(field) {
                if (field.create) {
                    openFieldEditor({ id: field.id, onSaved: () => this.callAPI() })
                } else {
                    openFieldEditor({ name: field.name, table: field.table, onSaved: () => this.callAPI() })
                }
            },

            editDroit(field){
                openRightsEditor({ id: field.id, target: 'field', root: 'interface' })
            }


        },
        mounted() {

            this.params = this.$store.getters.specificPage(this.modalKey).params    
            this.querys = this.$store.getters.specificPage(this.modalKey).querys

           
           let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 
 
        },

        beforeDestroy() {
            if(this.typeSave === 'vuex' && this.keyForm) {
                this.$store.dispatch('removeIForm', this.keyForm)
            }
        },

    }

</script>

<style scoped>
.form-module__field ::v-deep .v-text-field {
    padding-top: 2px;
}
.form-module__field ::v-deep .v-text-field__details {
    min-height: 10px;
    margin-bottom: 2px;
}
.form-module__field ::v-deep .v-messages {
    min-height: 10px;
}
.form-module__field ::v-deep .v-input--selection-controls {
    margin-top: 4px;
    padding-top: 0;
}
</style>

